import { Paper, styled } from "@mui/material";

export const StyledChatInterface = styled(Paper)({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  position: "relative",
  alignContent: "center",
  padding: "20px",
});
